import { PromotionType } from '@pbl/pbl-react-core/lib/models/draws/types';
import { SessionService } from '@pbl/pbl-react-core/lib/services/session-service';
import AccountReactivationScreen from '@pbl/pbl-react-widgets/lib/modules/AccountReactivationWidget';
import ForgotPasswordScreen from '@pbl/pbl-react-widgets/lib/modules/ForgotPasswordWidget';
import GamesUnclaimedPrizesScreen from '@pbl/pbl-react-widgets/lib/modules/GamesUnclaimedPrizesWidget';
import HistoryScreen from '@pbl/pbl-react-widgets/lib/modules/HistoryWidget';
import LoginScreen from '@pbl/pbl-react-widgets/lib/modules/LoginWidget';
import NumberCheckerWidget from '@pbl/pbl-react-widgets/lib/modules/NumberCheckerWidget';
import PasswordResetScreen from '@pbl/pbl-react-widgets/lib/modules/PasswordResetWidget';
import PromotionDetailWidget from '@pbl/pbl-react-widgets/lib/modules/PromotionDetailWidget';
import PromotionListWidget from '@pbl/pbl-react-widgets/lib/modules/PromotionListWidget';
import UserRegistrationScreen from '@pbl/pbl-react-widgets/lib/modules/RegistrationWidget';
import ScratchGamesUnclaimedPrizesScreen from '@pbl/pbl-react-widgets/lib/modules/ScratchGameUnclaimedPrizesWidget';
import SettingsScreen from '@pbl/pbl-react-widgets/lib/modules/SettingsWidget';
import TicketScreen from '@pbl/pbl-react-widgets/lib/modules/TicketEntryWidget';
import AccountActivationScreen from '@pbl/pbl-react-widgets/lib/modules/UserActivationWidget';
import PromoCodeScreen from '@pbl/pbl-react-widgets/lib/modules/PromoCodeWidget/index';
import SurveyScreen from '@pbl/pbl-react-widgets/lib/modules/SurveyWidget/index';
import ViewUrlScreen from '@pbl/pbl-react-widgets/lib/modules/ViewUrlWidget/index';
import PollScreen from '@pbl/pbl-react-widgets/lib/modules/PollWidget/index';
import InteractiveGameScreen from '@pbl/pbl-react-widgets/lib/modules/InteractiveWidget/index';
import { isAuthenticated, loginWithTokenWithProvider } from '@pbl/pbl-react-widgets/lib/redux/reducers/authentication/actions';
import { getFeatureFlags } from '@pbl/pbl-react-widgets/lib/redux/reducers/feature/actions';
import { ILoginResponse } from '@pbl/pbl-react-widgets/lib/utils/auth-service';
import { IAppNavigate, IGoInterface, IGoInternalInterface } from '@pbl/pbl-react-widgets/lib/widgets/framework.types';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import WidgetRenderer from './WidgetRenderer';
import EarnScreen from '@pbl/pbl-react-widgets/lib/modules/EarnWidget/index';
import RewardScreen from '@pbl/pbl-react-widgets/lib/modules/RewardWidget/index';
import QuizScreen from '@pbl/pbl-react-widgets/lib/modules/QuizWidget/index';
import NumberCheckerGamesListWidget from '@pbl/pbl-react-widgets/lib/modules/NumberCheckerWidget/listIndex';
import { INumberCheckerGameBoardConfig } from '@pbl/pbl-react-core/lib/models/jackpot/types';
import NumberCheckerGameConfigs from '@pbl/pbl-react-widgets/lib/config/numberCheckerGameConfigs';
import NumberCheckerDetailScreen from '@pbl/pbl-react-widgets/lib/modules/NumberCheckerWidget/details';
import RewardDetailWidget from '@pbl/pbl-react-widgets/lib/modules/RewardDetailWidget';
import constants from 'config/constants';
import { GoFwInternalInstance } from '@pbl/pbl-react-widgets/lib/widgets/framework';
import ActivityDetailsScreen from '@pbl/pbl-react-widgets/lib/modules/ActivityDetailsWidget/index';
import { INeoSession } from '@pbl/pbl-react-core/lib/models/user-registration/types';
import { store } from 'redux/store';
import { persistStorage } from 'utils/persist';
import KenoScreen from 'module/keno/keno-screen';
import HotColdScreen from 'module/keno/hot-cold-screen';

interface IProps {
  goFw: IGoInterface;
  goFwInternal: IGoInternalInterface;
}

const Widgets: React.FC<IProps> = ({ goFw, goFwInternal }) => {
  const dispatch = useDispatch();

  const loginSuccessCallback = () => (): void => {
    const appNavigate: IAppNavigate = {
      action: 'PROFILE'
    };
    goFwInternal.onHostNavigate(appNavigate);
  };

  const [numberCheckerSelector, setNumberCheckerSelector] = useState<string | null>(null);
  const [promotionListSelector, setPromotionListSelector] = useState<string | null>(null);
  const [drawListSelector, setDrawListSelector] = useState<string | null>(null);
  const [drawDetailSelector, setDrawDetailSelector] = useState<string | null>(null);
  const [promotionDetailSelector, setPromotionDetailSelector] = useState<string | null>(null);
  const [historySelector, setHistorySelector] = useState<string | null>(null);
  const [loginSelector, setLoginSelector] = useState<string | null>(null);
  const [forgotPasswordSelector, setForgotPasswordSelector] = useState<string | null>(null);
  const [resetPasswordSelector, setResetPasswordSelector] = useState<string | null>(null);
  const [reactivationSelector, setReactivationSelector] = useState<string | null>(null);
  const [activationSelector, setActivationSelector] = useState<string | null>(null);
  const [registerSelector, setRegisterSelector] = useState<string | null>(null);
  const [settingsSelector, setsettingsSelector] = useState<string | null>(null);
  const [promotionType, setPromotionType] = useState<string | null>(null);
  const [identifier, setIdentifier] = useState<string | null>(null);
  const [passwordResetKey, setPasswordResetKey] = useState<string | null>(null);
  const [activateKey, setActivateKey] = useState<string | null>(null);
  const [reactivateKey, setReactivateKey] = useState<string | null>(null);
  const [onLoginCallback, setOnLoginCallback] = useState<(() => void) | undefined>(undefined);
  const [ticketEntrySelector, setTicketEntrySelector] = useState<string | null>(null);
  const [lottoGamesUnclaimedPrizesSelector, setlottoGamesUnclaimedPrizesSelector] = useState<string | null>(null);
  const [scratchGamesUnclaimedPrizesSelector, setScratchGamesUnclaimedPrizesSelector] = useState<string | null>(null);
  const [promoCodeSelector, setPromoCodeSelector] = useState<string | null>(null);
  const [gameSelector, setGameSelector] = useState<string | null>(null);
  const [hotColdSelector, setHotColdSelector] = useState<string | null>(null);
  const [viewUrlSelector, setViewUrlSelector] = useState<string | null>(null);
  const [pollSelector, setPollSelector] = useState<string | null>(null);
  const [activitiesListSelector, setactivitiesListSelector] = useState<string | null>(null);
  const [surveySelector, setSurveySelector] = useState<string | null>(null);
  const [projectName, setProjectName] = useState<string | null>(null);
  const [quizSelector, setQuizSelector] = useState<string | null>(null);
  const [numberCheckerSelectorGameList, setNumberCheckerSelectorGameList] = useState<string | null>(null);
  const [numberCheckerGameConfigs, setNumberCheckerGameConfigs] = useState<INumberCheckerGameBoardConfig[]>([]);
  const [numberCheckerSelectorGameDetail, setNumberCheckerSelectorGameDetail] = useState<string | null>(null);
  const [rewardListSelector, setRewardListSelector] = useState<string | null>(null);
  const [rewardDetailSelector, setRewardDetailSelector] = useState<string | null>(null);
  const [resetData, setResetData] = useState<boolean>(false);
  const [showInteractiveGameSelector, setShowInteractiveGameSelector] = useState<string | null>(null);
  const [activityDetailsSelector, setActivityDetailsSelector] = useState<string | null>(null);
  const [ngFwReady, setNgFwReady] = useState<boolean>(false);
  const [checkSessionIteration, setCheckSessionIteration] = useState(0);
  const NEO_SESSION_TOKEN = `gameon.neoSessionToken`;

  const sessionListener = async (ngSession: INeoSession | null, onLoad?: any) => {
    console.info("SessionListener invoked!")
    // @ts-ignore
    const isLoggedIn = await window.go_fw.getSessionDetails();
    const storedNeoSessionToken = persistStorage.getItem(NEO_SESSION_TOKEN);
    // clear session if NG session is null.
    if ((!ngSession || ngSession.Status !== 'Login') && isLoggedIn.isValid) {
      // @ts-ignore
      await window.go_fw.logout();
      persistStorage.removeItem(NEO_SESSION_TOKEN);
    } else if (!isLoggedIn.isValid && !!ngSession && ngSession.Status === 'Login') {
    // @ts-ignore
      await window.po_fw.loginWithTokenWithProvider({sessionToken: ngSession.SessionToken,playerId: ngSession.PlayerID}, 'NEO', () => {
      persistStorage.setItem(NEO_SESSION_TOKEN,ngSession.SessionToken);
      console.info("Login sucess");
    });
    } 
    else if (!!ngSession && isLoggedIn.isValid && ngSession.SessionToken !== storedNeoSessionToken) {
      // @ts-ignore
      await window.po_fw.loginWithTokenWithProvider({sessionToken: ngSession.SessionToken,playerId: ngSession.PlayerID}, 'NEO', () => {
      persistStorage.setItem(NEO_SESSION_TOKEN,ngSession.SessionToken);
      console.info("Login sucess");
    });
    } else {
      if (onLoad) {
        onLoad();
      }
      // @ts-ignore
      await window.ng_fw.keepAlive();
    }
    // only fetch getLoyalty summary if logged in.
    if (!!ngSession) {
      // @ts-ignore
      await window.go_fw.getLoyaltySummary()
    }
  };

  const setSession = async (neoSession: any = null) => {
    console.info("setting session!")
    // @ts-ignore
    const ngSession = !!neoSession ? neoSession : window.ng_fw.getSessionDetails();
    if (ngSession === null) {
      await sessionListener(null, () => {
        if (window.poReady) {
          window.poReady();
        }
      });
    } else {
      const session: INeoSession = {
        PlayerID: ngSession.PlayerID,
        Status: `Login`,
        SessionToken: ngSession.SessionToken,
        CountryCode: ngSession.CountryCode,
        LastLoginTimeStamp: ngSession.LastLoginTimeStamp,
        LastUpdatedServerTimeStamp: ngSession.LastUpdatedServerTimeStamp,
        LoginTimeStamp: ngSession.LoginTimeStamp,
        PlayerRegulationType: ngSession.PlayerRegulationType,
        ServerLocalTimeStamp: ngSession.ServerLocalTimeStamp,
        ServerTimeStamp: ngSession.ServerTimeStamp,
      };
      sessionListener(session, () => {
        if (window.poReady) {
          window.poReady();
        }
      });
    }
  };

  const checkSession = async (): Promise<void> => {
    console.info("checking session!")
    const intervalTimeout = 100; // check after every 100 milliseconds
    const intervals = Math.ceil(constants.NEO_SESSION_TIMEOUT / intervalTimeout);
    // @ts-ignore
    const neoSession = window.ng_fw.getSessionDetails();
    if (
      checkSessionIteration > intervals ||
      (!!neoSession &&
        typeof neoSession === 'object' &&
        neoSession.hasOwnProperty('PlayerID') &&
        neoSession.hasOwnProperty('SessionToken') &&
        !!neoSession.PlayerID &&
        !!neoSession.SessionToken)
    ) {
      setSession(neoSession);
    } else {
      await setCheckSessionIteration(checkSessionIteration + 1 );
      // removing time out and trust NEO's session.
      setSession(neoSession);
    }
  };

  const subscribeNgHsEvents = async () => {
    console.info("Subscribe to session listener")
    if (ngFwReady) {
      return;
    }
    setNgFwReady(true)
    // register events from ng
    // @ts-ignore
    ng_hs.onSessionStatusUpdate((ngSession: INeoSession) => {
      sessionListener(ngSession);
    });
    await checkSession();
  };

  useEffect(() => {
    registerWidgetLoaders();

    // @ts-ignore
    if (window.goReady) {
      // @ts-ignore
      window.goReady();
    }

    // @ts-ignore
    if (window.poReady) {
      // @ts-ignore
      window.poReady();
    }
    document.addEventListener('fwReady', subscribeNgHsEvents);
    // @ts-ignore
    if(!constants.IS_DEVELOPMENT_MODE){
      // @ts-ignore
      const neoSession = window?.ng_fw?.getSessionDetails();
      // if we have null session or session have player and not ErrorCode: -1, ErrorMessage: "NG FW is not ready. Time: 2019-08-16T16:34:40.914Z"
      if (
        neoSession === null ||
        (!!neoSession &&
          typeof neoSession === 'object' &&
          neoSession.hasOwnProperty('PlayerID') &&
          neoSession.hasOwnProperty('SessionToken'))
      ) {
         subscribeNgHsEvents();
      }
    }

    dispatch(isAuthenticated());
    dispatch(getFeatureFlags());
    ///document.removeEventListener('fwReady', subscribeNgHsEvents);
  }, []);

  const showNumberChecker = (): React.ReactNode => {
    if (!numberCheckerSelector) {
      return null;
    }

    return (
      <WidgetRenderer selector={numberCheckerSelector}>
        <NumberCheckerWidget gameConfigs={[]} />
      </WidgetRenderer>
    );
  };

  const showNumberCheckerWithAGame = (): React.ReactNode => {
    if (!numberCheckerSelector) {
      return null;
    }

    return (
      <WidgetRenderer selector={numberCheckerSelector}>
        <NumberCheckerWidget identifier={Number(identifier)} gameConfigs={[]} />
      </WidgetRenderer>
    );
  };

  const showPromotionList = (): React.ReactNode => {
    if (!promotionListSelector) {
      return null;
    }

    return (
      <WidgetRenderer selector={promotionListSelector}>
        <PromotionListWidget promotionType={promotionType as PromotionType} />
      </WidgetRenderer>
    );
  };

  const showPromotionDetail = (): React.ReactNode => {
    if (!promotionDetailSelector) {
      return null;
    }

    return (
      <WidgetRenderer selector={promotionDetailSelector}>
        <PromotionDetailWidget identifier={Number(identifier)} hideEligibleGames={true} showSuperBonus={true} />
      </WidgetRenderer>
    );
  };

  const showDrawCatalog = (): React.ReactNode => {
    if (!drawListSelector) {
      return null;
    }
 
    return (
      <WidgetRenderer selector={drawListSelector}>
        <PromotionListWidget promotionType={PromotionType.SECOND_CHANCE} />
      </WidgetRenderer>
    );
  };
 
  const showDraw = (): React.ReactNode => {
    if (!drawDetailSelector) {
      return null;
    }
 
    return (
      <WidgetRenderer selector={drawDetailSelector}>
        <PromotionDetailWidget identifier={Number(identifier)} hideEligibleGames={true} showSuperBonus={true} />
      </WidgetRenderer>
    );
  };

  const showNumberCheckerGamesList = (): React.ReactNode => {
    if (!numberCheckerSelectorGameList) {
      return null;
    }

    return (
      <WidgetRenderer selector={numberCheckerSelectorGameList}>
        <NumberCheckerGamesListWidget />
      </WidgetRenderer>
    );
  };

  const showHistory = (): React.ReactNode => {
    if (!historySelector) {
      return null;
    }

    return (
      <WidgetRenderer selector={historySelector}>
        <HistoryScreen showWinnerAnnouncementDateInsteadOfDrawDate={constants.SHOW_WINNER_ANNOUNCEMENT_DATE} showHeadingTitle={true} showDigitalReveal={true} showEinstantTabFirst={true}/>
      </WidgetRenderer>
    );
  };

  const showLogin = (): React.ReactNode => {
    if (!loginSelector || !onLoginCallback) {
      return null;
    }

    return (
      <WidgetRenderer selector={loginSelector}>
        <LoginScreen onLoginCallback={onLoginCallback} />
      </WidgetRenderer>
    );
  };

  const showForgotPassword = (): React.ReactNode => {
    if (!forgotPasswordSelector) {
      return null;
    }

    return (
      <WidgetRenderer selector={forgotPasswordSelector}>
        <ForgotPasswordScreen />
      </WidgetRenderer>
    );
  };

  const showAccountReactivation = (): React.ReactNode => {
    if (!reactivationSelector) {
      return null;
    }
    return (
      <WidgetRenderer selector={reactivationSelector}>
        <AccountReactivationScreen identifier={reactivateKey || ''} />
      </WidgetRenderer>
    );
  };

  const showActivation = (): React.ReactNode => {
    if (!activationSelector) {
      return null;
    }
    return (
      <WidgetRenderer selector={activationSelector}>
        <AccountActivationScreen identifier={activateKey || ''} />
      </WidgetRenderer>
    );
  };

  const showResetPassword = (): React.ReactNode => {
    if (!resetPasswordSelector) {
      return null;
    }
    return (
      <WidgetRenderer selector={resetPasswordSelector}>
        <PasswordResetScreen identifier={passwordResetKey || ''} />
      </WidgetRenderer>
    );
  };

  const showRegister = (): React.ReactNode => {
    if (!registerSelector) {
      return null;
    }

    return (
      <WidgetRenderer selector={registerSelector}>
        <UserRegistrationScreen />
      </WidgetRenderer>
    );
  };

  const showSettings = (): React.ReactNode => {
    if (!settingsSelector) {
      return null;
    }

    return (
      <WidgetRenderer selector={settingsSelector}>
        <SettingsScreen showHeadingTitle={false} />
      </WidgetRenderer>
    );
  };

  const showTicketEntry = (): React.ReactNode => {
    if (!ticketEntrySelector) {
      return null;
    }

    return (
      <WidgetRenderer selector={ticketEntrySelector}>
        <TicketScreen
          messageTimeout={constants.MESSAGE_BAR_TIMEOUT_TICKET_SCREEN}
          navigateToGames={() => {
            GoFwInternalInstance.onHostNavigate({
              action: 'GAMES_LIST'
            });
          }}
          resetData={resetData}
        />
      </WidgetRenderer>
    );
  };

  const showLottoGamesUnclaimedPrizesScreen = (): React.ReactNode => {
    if (!lottoGamesUnclaimedPrizesSelector) {
      return null;
    }

    return (
      <WidgetRenderer selector={lottoGamesUnclaimedPrizesSelector}>
        <GamesUnclaimedPrizesScreen gameTypes={[2, 7]} />
      </WidgetRenderer>
    );
  };

  const showScratchGamesUnclaimedPrizesScreen = (): React.ReactNode => {
    if (!scratchGamesUnclaimedPrizesSelector) {
      return null;
    }

    return (
      <WidgetRenderer selector={scratchGamesUnclaimedPrizesSelector}>
        <ScratchGamesUnclaimedPrizesScreen />
      </WidgetRenderer>
    );
  };

  const showPromoCode = (): React.ReactNode => {
    if (!promoCodeSelector) {
      return null;
    }

    return (
      <WidgetRenderer selector={promoCodeSelector}>
        <PromoCodeScreen identifier={Number(identifier)} hideBackBtn={true} />
      </WidgetRenderer>
    );
  };


  const showGame = (): React.ReactNode => {
    if (!gameSelector) {
      return null;
    }

    return (
      <WidgetRenderer selector={gameSelector}>
        <KenoScreen/>
      </WidgetRenderer>
    );
  };

  const showHotCold = (): React.ReactNode => {
    if (!hotColdSelector) {
      return null;
    }

    return (
      <WidgetRenderer selector={hotColdSelector}>
        <HotColdScreen 
        />
      </WidgetRenderer>
    );
  };

  const showViewUrl = (): React.ReactNode => {
    if (!viewUrlSelector) {
      return null;
    }

    return (
      <WidgetRenderer selector={viewUrlSelector}>
        <ViewUrlScreen identifier={Number(identifier)} hideBackBtn={false} />
      </WidgetRenderer>
    );
  };

  const showPoll = (): React.ReactNode => {
    if (!pollSelector) {
      return null;
    }

    return (
      <WidgetRenderer selector={pollSelector}>
        <PollScreen identifier={Number(identifier)} hideBackBtn={false} />
      </WidgetRenderer>
    );
  };

  const showActivityList = (): React.ReactNode => {
    if (!activitiesListSelector) {
      return null;
    }

    return (
      <WidgetRenderer selector={activitiesListSelector}>
        <EarnScreen projectName={projectName as string} />
      </WidgetRenderer>
    );
  };

  const showRewardList = (): React.ReactNode => {
    if (!rewardListSelector) {
      return null;
    }

    return (
      <WidgetRenderer selector={rewardListSelector}>
        <RewardScreen projectName={projectName as string} />
      </WidgetRenderer>
    );
  };

  const showRewardDetail = (): React.ReactNode => {
    if (!rewardDetailSelector) {
      return null;
    }

    return (
      <WidgetRenderer selector={rewardDetailSelector}>
        <RewardDetailWidget identifier={Number(identifier)} />
      </WidgetRenderer>
    );
  };

  const showSurvey = (): React.ReactNode => {
    if (!surveySelector) {
      return null;
    }

    return (
      <WidgetRenderer selector={surveySelector}>
        <SurveyScreen identifier={Number(identifier)} hideBackBtn={false} />
      </WidgetRenderer>
    );
  };
  const showQuiz = (): React.ReactNode => {
    if (!quizSelector) {
      return null;
    }

    return (
      <WidgetRenderer selector={quizSelector}>
        <QuizScreen identifier={Number(identifier)} />
      </WidgetRenderer>
    );
  };

  const showNumberCheckerGameDetail = (): React.ReactNode => {
    if (!numberCheckerSelectorGameDetail) {
      return null;
    }
    let numberCheckerGameConfig = numberCheckerGameConfigs;

    if (!numberCheckerGameConfigs || !numberCheckerGameConfigs.length) {
      numberCheckerGameConfig = NumberCheckerGameConfigs;
    }

    return (
      <WidgetRenderer selector={numberCheckerSelectorGameDetail}>
        <NumberCheckerDetailScreen identifier={Number(identifier)} gameConfigs={numberCheckerGameConfig} />
      </WidgetRenderer>
    );
  };

  const showInteractiveGame = (): React.ReactNode => {
    if (!showInteractiveGameSelector) {
      return null;
    }

    return (
      <WidgetRenderer selector={showInteractiveGameSelector}>
        <InteractiveGameScreen identifier={Number(identifier)} hideBackBtn={false} />
      </WidgetRenderer>
    );
  };

  const showActivityDetails = (): React.ReactNode => {
    if (!activityDetailsSelector) {
      return null;
    }

    return (
      <WidgetRenderer selector={activityDetailsSelector}>
        <ActivityDetailsScreen identifier={Number(identifier)}/>
      </WidgetRenderer>
    );
  };

  const registerWidgetLoaders = () => {
    goFw.showNumberChecker = (selector: string, id?: string) => {
      if (id) {
        setIdentifier(id);
      }
      setNumberCheckerSelector(selector);
    };

    goFw.showNumberCheckerGameDetail = (selector: string, id: string, numberCheckerGameConfigs: INumberCheckerGameBoardConfig[]) => {
      setIdentifier(id);
      setNumberCheckerGameConfigs(numberCheckerGameConfigs);
      setNumberCheckerSelectorGameDetail(selector);
    };

    goFw.showNumberCheckerGamesList = (selector: string, id?: string) => {
      if (id) {
        setIdentifier(id);
      }
      setNumberCheckerSelectorGameList(selector);
    };

    goFw.showTicketEntry = (selector: string, resetData?: boolean) => {
      if (resetData) {
        setResetData(resetData);
      }
      setTicketEntrySelector(selector);
    };

    goFw.showPromotionList = (selector: string, type: string) => {
      setPromotionType(type);
      setPromotionListSelector(selector);
    };

    goFw.showPromotionDetail = (selector: string, id: string) => {
      setIdentifier(id);
      setPromotionDetailSelector(selector);
    };

    goFw.showDrawCatalog = (selector: string) => {
      setDrawListSelector(selector);
    };

    goFw.showDraw = (selector: string, id: string) => {
      setIdentifier(id);
      setDrawDetailSelector(selector);
    };

    goFw.showHistory = (selector: string) => {
      setHistorySelector(selector);
    };

    goFw.showLogin = (selector: string, callback?: () => void) => {
      setLoginSelector(selector);
      if (callback) {
        setOnLoginCallback(callback);
      } else {
        setOnLoginCallback(loginSuccessCallback);
      }
    };

    goFw.loginWithTokenWithProvider = (
      request: Record<string, any> | ILoginResponse,
      provider: string,
      callback?: (response?: ILoginResponse) => void
    ) => {
      SessionService.status().then();
      SessionService.statusPost().finally(() => {
        const defaultCallback = () => {
          console.warn(`Login success`);
        };
        const successCallback = callback ?? defaultCallback;
        // @ts-ignore
        store.dispatch(loginWithTokenWithProvider(request, provider, successCallback));
      });
    };

    goFw.showForgotPassword = (selector: string) => {
      setForgotPasswordSelector(selector);
    };

    goFw.showResetPassword = (selector: string, key: string) => {
      setResetPasswordSelector(selector);
      setPasswordResetKey(key);
    };

    goFw.showAccountReactivation = (selector: string, key: string) => {
      setReactivationSelector(selector);
      setReactivateKey(key);
    };

    goFw.showActivation = (selector: string, key: string) => {
      setActivationSelector(selector);
      setActivateKey(key);
    };

    goFw.showResetPassword = (selector: string, key: string) => {
      setResetPasswordSelector(selector);
      setPasswordResetKey(key);
    };

    goFw.showRegister = (selector: string) => {
      setRegisterSelector(selector);
    };

    goFw.showSettings = (selector: string) => {
      setsettingsSelector(selector);
    };

    goFw.showLottoGamesUnclaimedPrizes = (selector: string) => {
      setlottoGamesUnclaimedPrizesSelector(selector);
    };

    goFw.showScratchGamesUnclaimedPrizes = (selector: string) => {
      setScratchGamesUnclaimedPrizesSelector(selector);
    };

    goFw.showPromoCode = (selector: string, id?: string) => {
      if (id) {
        setIdentifier(id);
      }
      setPromoCodeSelector(selector);
    };

    goFw.showGame = (selector: string, id?: string) => {
      if (id) {
        setIdentifier(id);
      }
      setGameSelector(selector);
    };

    goFw.showHotCold = (selector: string, id: string) => {
      if (id) {
        setIdentifier(id);
      }
      setHotColdSelector(selector);
    };

    goFw.showViewUrl = (selector: string, id?: string) => {
      if (id) {
        setIdentifier(id);
      }
      setViewUrlSelector(selector);
    };

    goFw.showPoll = (selector: string, id?: string) => {
      if (id) {
        setIdentifier(id);
      }
      setPollSelector(selector);
    };

    goFw.showActivityList = (selector: string, name: string) => {
      setProjectName(name);
      setactivitiesListSelector(selector);
    };

    goFw.showSurvey = (selector: string, id?: string) => {
      if (id) {
        setIdentifier(id);
      }
      setSurveySelector(selector);
    };

    goFw.showQuiz = (selector: string, id: string) => {
      setIdentifier(id);
      setQuizSelector(selector);
    };

    goFw.showRewardList = (selector: string) => {
      setRewardListSelector(selector);
    };

    goFw.showRewardDetail = (selector: string, id: string) => {
      setIdentifier(id);
      setRewardDetailSelector(selector);
    };

    goFw.showInteractiveGame = (selector: string, id?: string) => {
      if (id) {
        setIdentifier(id);
      }
      setShowInteractiveGameSelector(selector);
    };

    goFw.showActivityDetails = (selector: string, id?: string, _projectName?: string) => {
      if (id) {
        setIdentifier(id);
      }
      setActivityDetailsSelector(selector);
    };
  };

  return (
    <>
      {!!identifier ? showNumberCheckerWithAGame() : showNumberChecker()}
      {showPromotionList()}
      {showPromotionDetail()}
      {showHistory()}
      {showLogin()}
      {showForgotPassword()}
      {showResetPassword()}
      {showAccountReactivation()}
      {showActivation()}
      {showRegister()}
      {showSettings()}
      {showTicketEntry()}
      {showLottoGamesUnclaimedPrizesScreen()}
      {showScratchGamesUnclaimedPrizesScreen()}
      {showPromoCode()}
      {showGame()}
      {showHotCold()}
      {showViewUrl()}
      {showPoll()}
      {showActivityList()}
      {showSurvey()}
      {showQuiz()}
      {showNumberCheckerGamesList()}
      {showNumberCheckerGameDetail()}
      {showRewardList()}
      {showRewardDetail()}
      {showInteractiveGame()}
      {showActivityDetails()}
      {showDraw()}
      {showDrawCatalog()}
    </>
  );
};

export default Widgets;
